<!-- @format -->

<mynumber-browsing-application-tag>

  <style>
    .reply_result_waiting_reply{

    }
    .reply_result_reject{
      font-weight: bold;
      color:red;
    }
    .reply_result_accept{
      font-weight: bold;
      color:blue;
    }
    .button-reject {
        background-color: #E02040;
    }
    .button-reject:hover {
      background-color: #E02040;
      opacity: 0.5;
    }
    .contents_table tr.expired td {
      background-color: silver;
    }
    .contents_table tr.expired:nth-child(odd) td {
      /*background-color: #9b9b9b;*/
    }
    .contents_table tr td {
      vertical-align: middle;
    }
    .contents_table tr th{
      text-align: center;
      vertical-align: middle;
    }
    .contents_table tr td,
    .contents_table tr th{
      font-size: 1.1rem;
      border:1px solid grey;
      padding:1rem;
    }
  </style>

  <div class="container_breadcrumb">
    <ul class="breadcrumb">
      <li class="breadcrumb-item">
        <h1 class="heading-01 heading_home">マイナンバー閲覧申請一覧</h1>
      </li>
    </ul>
  </div>
  <!--/.container_breadcrumb-->

  <div class="contents">

    <p class="text">
      こちらでは今までにクライアント様から申請されたマイナンバーの閲覧申請とその返信結果を一覧で表示しています。
    </p>
    <p class="text" style="font-weight:bold">
      閲覧期限に年月日が記載されているクライアント様については、その年月日までマイナンバーをクライアント様が閲覧出来ます。
    </p>

    <section class="contents_area">
      <div class="contents_block detail">

        <table class="contents_table pay-detail_table margin-spacing-3_top">
          <tbody>


          <tr>
            <th>クライアント名</th>
            <th>申請年月日</th>
            <th style="text-align: center;width:11rem;">クライアントへの返信</th>
            <th style="text-align: center">マイナンバーの<br>閲覧期限</th>
            <th>クライアント様からの<br>申請時メッセージ</th>
            <th>返信時メッセージ</th>
          </tr>

          <tr each="{ application in state.application_list }"  class="{((application.state == 30) || (application.state == 40) || (application.state == 50)) ? 'expired' : ''}">
            <td>{application.client_name}</td>
            <td>{date_format(application.application_datetime)}</td>
            <td style="text-align: center">
              <!--
              <span if={application.state == 20}>未返信</span>
              <span if={application.state == 30} class="reply_result_reject">却下</span>
              <span if={application.state == 40 || application.state == 50} class="reply_result_accept">承諾</span>
              -->

              <div class="wrap_button11" if={application.state == 20}>

                <div
                        style="font-size: 1.1rem"
                        class="button button-secondary-mini margin-spacing-1_bottom"
                        onclick="{ e => openAcceptModal(application.application_id) }"
                >
                  承諾する
                </div>

                <div
                        style="font-size: 1.1rem"
                        class="button button-secondary-mini button-reject"
                        onclick="{ e => openRejectModal(application.application_id) }"
                >
                  辞退する
                </div>
              </div>
              <span if={application.state == 30} class="reply_result_reject">辞退</span>
              <span if={application.state == 40 || application.state == 50} class="reply_result_accept">承諾</span>

            </td>
            <td style="text-align: center">
              <span if={application.expire_time == "0000-00-00 00:00:00"}>---</span>
              <span if={(application.state == 40 || application.state == 50) && (application.expire_time != "0000-00-00 00:00:00")}>{date_format(application.expire_time)}</span>

            </td>
            <td>{application.request_message}</td>
            <td>{application.reply_message}</td>

          </tr>

          </tbody>
        </table>

      </div>
      <!--/.contents_block-->
    </section>
    <!--/.contents_area-->
  </div>

  <accept-modal-tag
          is-open="{ state.acceptModalIsOpen }"
          on-close="{ e => { update({acceptModalIsOpen: false}) } }"
          on-accept="{ onAccept }"
          target_application_id={state.target_application_id}
  ></accept-modal-tag>
  <reject-modal-tag
          is-open="{ state.rejectModalIsOpen }"
          on-close="{ e => { update({rejectModalIsOpen: false}) } }"
          on-reject="{ onReject }"
          target_application_id={state.target_application_id}
  ></reject-modal-tag>

  <script>

    import di from "dependeny-injection";
    import dayjs     from "dayjs";
    import acceptModal from "@tags/modal/menu/mynumber-browsing-application/accept-modal.riot";
    import rejectModal from "@tags/modal/menu/mynumber-browsing-application/reject-modal.riot";

    export default {
      components:{
        "accept-modal-tag" : acceptModal,
        "reject-modal-tag" : rejectModal,
      },
      state:{
        acceptModalIsOpen:false,
        rejectModalIsOpen:false,
        target_application_id : 0
      },
      date_format(datetime){
        return dayjs(datetime).format("YYYY年MM月DD日 HH時mm分");
      },
      goTo(link){
        di.router.push(link);
      },
      onMounted(props, state) {
        //this.search.on("update:index", this.listenerUpdate);
      },
      onUnmounted(props, state) {
        //this.search.off("update:index", this.listenerUpdate);
        //this.search.isClear = true;
      },
      onBeforeMount(){
        this.api = di.createApi('menu');
        this.fetchList();
      },
      async fetchList(){
        const res = await this.api.request(
                "mynumber-browsing-application",
                "fetch-list",
                {}
        );
        this.update({ application_list: res });

      },
      openAcceptModal(application_id){
        this.state.target_application_id = application_id;
        this.update({acceptModalIsOpen:true});

      },
      openRejectModal(application_id){
        this.state.target_application_id = application_id;
        this.update({rejectModalIsOpen:true});
      },
      onAccept(e){
        alert("申請に対して承諾で返信しました");
        this.update({acceptModalIsOpen:false});
        this.fetchList();
      },
      onReject(e){
        alert("申請に対して辞退で返信しました");
        this.update({rejectModalIsOpen:false});
        this.fetchList();
      }
    }
  </script>
</mynumber-browsing-application-tag>
